import * as z from "zod/v4";

export const MetaAdsConnectionSchema = z.object({
  redoSegment: z.object({ name: z.string(), id: z.string() }),
  metaAdsCustomAudience: z.object({ name: z.string(), id: z.string() }),
});

export type MetaAdsConnection = z.infer<typeof MetaAdsConnectionSchema>;
